import type { Resource } from '../../';
export const content_slider_goToSlide: Resource = {"default":"Go to slide {slideNumber}"};
